export const TEMP_CLIENT_ID_PREFIX = "new-"

export function isTempClientId(id: string): boolean {
  return id.startsWith(TEMP_CLIENT_ID_PREFIX)
}
